// extracted by mini-css-extract-plugin
export var paginationContainer = "_7u-0";